import { ChevronRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1 text-sm text-muted-foreground">
        <li>
          <Link to="/dashboard" className="hover:text-foreground">
            Home
          </Link>
        </li>
        {pathnames.map((path, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;

          return (
            <li key={path} className="flex items-center">
              <ChevronRight className="h-4 w-4" />
              {isLast ? (
                <span className="ml-1 font-medium text-foreground">
                  {path.charAt(0).toUpperCase() + path.slice(1)}
                </span>
              ) : (
                <Link to={routeTo} className="ml-1 hover:text-foreground">
                  {path.charAt(0).toUpperCase() + path.slice(1)}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
